const component = "tabs";

export const tabs = {
  component,
  item: `${component}/item`,
};
